export const COVERGO_SAAS_PROD = {
	COVERGO_GRAPHQL: "https://api.covergo.com/graphql",
	COVERGO_FILE_SYSTEM: "https://api.covergo.com/api/v1/files",
}

export const COVERGO_SAAS_DEV = {
	COVERGO_GRAPHQL: "https://api.dev.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.dev.covergo.cloud/api/v1/files",
}

export const COVERGO_EU_DEV = {
	COVERGO_GRAPHQL: "https://api.dev.eu.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.dev.eu.covergo.cloud/api/v1/files",
}

export const COVERGO_EU_UAT = {
	COVERGO_GRAPHQL: "https://api.uat.eu.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.uat.eu.covergo.cloud/api/v1/files",
}

export const COVERGO_EU_PROD = {
	COVERGO_GRAPHQL: "https://api.eu.covergo.com/graphql",
	COVERGO_FILE_SYSTEM: "https://api.eu.covergo.com/api/v1/files",
}

export const COVERGO_EU_PREPROD = {
	COVERGO_GRAPHQL: "https://api.preprod.eu.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.preprod.eu.covergo.cloud/api/v1/files",
}

export const COVERGO_ASIA_PROD = {
	COVERGO_GRAPHQL: "https://api.asia.covergo.com/graphql",
	COVERGO_FILE_SYSTEM: "https://api.asia.covergo.com/api/v1/files",
}

export const COVERGO_ASIA_PRE_PROD = {
	COVERGO_GRAPHQL: "https://api.preprod.asia.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.preprod.asia.covergo.cloud/api/v1/files",
}

export const COVERGO_AXATH_PROD = {
	COVERGO_GRAPHQL: "https://api.prod.axath.asia.covergo.net/graphql",
	COVERGO_FILE_SYSTEM: "https://api.prod.axath.asia.covergo.net/api/v1/files",
}

export const COVERGO_AXATH_UAT = {
	COVERGO_GRAPHQL: "https://api.uat.axath.asia.covergo.net/graphql",
	COVERGO_FILE_SYSTEM: "https://api.uat.axath.asia.covergo.net/api/v1/files",
}

export const COVERGO_ASIA_UAT = {
	COVERGO_GRAPHQL: "https://api.uat.asia.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.uat.asia.covergo.cloud/api/v1/files",
}

// https://covergo.atlassian.net/wiki/spaces/INFR/pages/1200390146/Saudi+Arabia+Prod+Cloud+Environment
export const COVERGO_ME_PROD = {
	COVERGO_GRAPHQL: "https://api.me.covergo.com/graphql",
	COVERGO_FILE_SYSTEM: "https://api.me.covergo.com/api/v1/files",
}

export const COVERGO_CA_UAT = {
	COVERGO_GRAPHQL: "https://api.uat.ca.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.uat.ca.covergo.cloud/api/v1/files",
}

export const COVERGO_CA_PROD = {
	COVERGO_GRAPHQL: "https://api.ca.covergo.com/graphql",
	COVERGO_FILE_SYSTEM: "https://api.ca.covergo.com/api/v1/files",
}

export const COVERGO_ASIA_QA = {
	COVERGO_GRAPHQL: "https://api.qa.asia.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.qa.asia.covergo.cloud/api/v1/files",
}

export const COVERGO_GCP_UAT = {
	COVERGO_GRAPHQL: "https://api.uat.me.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.uat.me.covergo.cloud/api/v1/files",
}

export const COVERGO_ASIA_DR = {
	COVERGO_GRAPHQL: "https://api.dr.asia.covergo.cloud/graphql",
	COVERGO_FILE_SYSTEM: "https://api.dr.asia.covergo.cloud/api/v1/files",
}
